"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  'alberta': 'ab',
  'british columbia': 'bc',
  'manitoba': 'mb',
  'new brunswick': 'nb',
  'newfoundland and labrador': 'nl',
  'northwest territories': 'nt',
  'nova scotia': 'ns',
  'nunavut': 'nu',
  'ontario': 'on',
  'prince edward island': 'pe',
  'quebec': 'qc',
  'saskatchewan': 'sk',
  'yukon': 'yt'
};
exports.default = _default;
//# sourceMappingURL=states_CA_map.js.map